module.exports = __webpack_public_path__ + "assets/images/delivery.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/delivery.png
// module id = 248
// module chunks = 1